import { useMemo } from 'react';

import { XStack, YStack } from '@/components/ui';
import { loaderPortalId } from '@/components/ui/logo-loader';
import { classList } from '@/utils/cn';

import { getWorkingWord } from './reasoning.utils';
import { SHIMMER_TEXT_CLASSES } from './ShimmerCollapsibleHeader';

type ThinkingIndicatorProps = {
  id: string;
  isCompact?: boolean;
};

export const ThinkingIndicator = ({
  id,
  isCompact = false,
}: ThinkingIndicatorProps) => {
  const workingWord = useMemo(() => getWorkingWord(), []);

  return (
    <YStack
      data-message-id={id}
      className={classList('relative gap-4 w-full py-3', !isCompact && 'px-6')}
    >
      {/* Portal target for StreamingLoader — position is carefully calibrated, verify changes visually */}
      <div
        id={loaderPortalId(id)}
        className={classList(
          'absolute',
          '-left-1.5',
          'top-2.5',
          'size-6',
          'pointer-events-none'
        )}
      />
      <XStack className="items-center gap-1 px-1 w-full">
        <span
          className={classList(
            'text-sm text-foreground select-none font-medium capitalize',
            ['bg-clip-text text-transparent', ...SHIMMER_TEXT_CLASSES]
          )}
        >
          {workingWord}...
        </span>
      </XStack>
      <YStack className="gap-2.5 px-1 hidden">
        <div
          className={classList(
            'h-3 w-3/4 rounded-md opacity-[0.04]',
            SHIMMER_TEXT_CLASSES
          )}
        />
        <div
          className={classList(
            'h-3 w-1/2 rounded-md opacity-[0.04]',
            SHIMMER_TEXT_CLASSES
          )}
        />
      </YStack>
    </YStack>
  );
};
